import PermissionsCustomView from "../../../gd/access-control/permissions/custom-view"
import {ViewType} from "../../../gd/const/views/view-type"
import {createCustomDashboard} from "../../../../app/quick-add/sections/dashboard/actions/create-custom-dashboard"
import {DashboardType} from "../../../gd-modules/dashboard/model/dashboard/types"
import {NavigationSectionType} from "../../navigation/@const"
import {QuickAddItemType} from "../../../../app/quick-add/@types"
import getCustomViewDefaultLocation from "../actions/get-default-location"
import {AddView_Group, AddView_GroupType} from "../../../gd-ui/add-view/@types";
import {PROJECT_LIST_CONFIG} from "../../../views/list/@config";
import {PROJECT_TABLE_CONFIG} from "../../../views/table/@config"
import {PROJECT_BOARD_CONFIG} from "../../../views/board/@config";
import {PROJECT_CALENDAR_CONFIG} from "../../../views/calendar/@config"
import {CUSTOM_VIEW_EVENTS_SUMMARY_CONFIG} from "../../../views/events-summary/@config"
import {MY_DOCUMENTS_CONFIG} from "../../view/personal-view/views/my-documents";
import {MY_GOALS_CONFIG} from "../../view/personal-view/views/my-goals";
import {MY_MEETINGS_CONFIG} from "../../view/personal-view/views/my-meetings";
import {CUSTOM_VIEW_EXPENSES_CONFIG} from "../../../views/expenses/@config-custom"
import {PROJECT_GANTT_CONFIG} from "../../../views/gantt/@config"
import {Feature} from "../../../gd/access-control/feature-access/const";
import {PROJECT_WORKLOAD_CONFIG} from "../../../views/workload/@config"
import {PROJECT_ACTIVITY_CONFIG} from "../../../views/activity/@config"
import {CUSTOM_VIEW_WHATS_DONE_CONFIG} from "../../../views/whats-done/@config"
import {CUSTOM_VIEW_CUSTOM_ENTITY_GLIST_CONFIG} from "../../../gd/const/views/configs/custom/custom-view-external-data-glist";
// import {MY_TASKS_LIST_CONFIG} from "../../view/personal-view/views/my-tasks-list";
// import {MY_WORK_CALENDAR_CONFIG} from "../../view/personal-view/views/my-work-calendar";
// import {MY_WORK_WORKLOAD_CONFIG} from "../../view/personal-view/views/my-work-workload";
// import {MY_TIME_CONFIG} from "../../view/personal-view/views/my-time";
// import {MY_ATTENDANCE_CONFIG} from "../../view/personal-view/views/my-attendance";
// import {MY_NOTES_CONFIG} from "../../view/personal-view/views/my-notes";
// import {MY_RECENT_CONFIG} from "../../view/personal-view/views/my-recent";
import {CUSTOM_VIEW_PASTDUE_CONFIG} from "../../../views/pastdue/@config";
import {CUSTOM_VIEW_PRIORITIES_CONFIG} from "../../../views/priorities/@config";
import {CUSTOM_VIEW_ACTION_REQUIRED_CONFIG} from "../../../views/action-required/@config";
import {CUSTOM_VIEW_TASKS_BY_USER_CONFIG} from "../../../views/tasks-by-user/@config";
import {PROJECTS_PORTFOLIO_CONFIG} from "../../../views/portfolio/@config";
import {PROJECTS_PROJECTS_LIST_CONFIG} from "../../../views/projects-list/@config";

export enum ViewsStructureFor {

    QUICK_ADD           = 1,
    NAVIGATION_SECTION  = 2,
    PROJECT_STRUCTURE   = 3

}

type Options = {
    navigationSectionType?  : NavigationSectionType
    projectId?              : ID
}

// const debug = "NewView_getViewsStructure"
const debug = false

export default function NewView_getViewsStructure(structureFor: ViewsStructureFor, options:Options={}) {

    debug && console.log(debug, 'process', options)

    const includeAll: boolean = structureFor !== ViewsStructureFor.QUICK_ADD
    const existingMyWorkViews   = gd.session.customViews.findExistingMyWorkViews()

    const params = {
        location        : options.navigationSectionType,
        parentProjectId : options.projectId
    }

    let structure: AddView_Group[] = [
        {
            type        : AddView_GroupType.GROUP,
            id          : 'tasks',
            icon        : 'i5-tasks',
            title       : 'Task Views',
            items       : [
                {
                    typeId          : ViewType.PROJECT_LIST,
                    iconSvg         : PROJECT_LIST_CONFIG.iconSvg,
                    title           : PROJECT_LIST_CONFIG.name,
                    description     : PROJECT_LIST_CONFIG.description,
                    onClick         : async () => {
                        gd.openNew(QuickAddItemType.VIEW, {...params, type: ViewType.PROJECT_LIST})
                    }
                },
                {
                    typeId          : ViewType.PROJECT_TABLE,
                    iconSvg         : PROJECT_TABLE_CONFIG.iconSvg,
                    title           : PROJECT_TABLE_CONFIG.name,
                    description     : PROJECT_TABLE_CONFIG.description,
                    onClick         : async () => {
                        gd.openNew(QuickAddItemType.VIEW, {...params, type: ViewType.PROJECT_TABLE})
                    }
                },
                {
                    typeId          : ViewType.PROJECT_BOARD,
                    iconSvg         : PROJECT_BOARD_CONFIG.iconSvg,
                    title           : PROJECT_BOARD_CONFIG.name,
                    description     : PROJECT_BOARD_CONFIG.description,
                    onClick         : async () => {
                        gd.openNew(QuickAddItemType.VIEW, {...params, type: ViewType.PROJECT_BOARD})
                    }
                },
            ]
        },
        {
            type        : AddView_GroupType.GROUP,
            id          : 'events',
            icon        : 'i5-calendar',
            title       : 'Events',
            items       : [
                {
                    typeId          : ViewType.PROJECT_CALENDAR,
                    iconSvg         : PROJECT_CALENDAR_CONFIG.iconSvg,
                    title           : PROJECT_CALENDAR_CONFIG.name,
                    description     : PROJECT_CALENDAR_CONFIG.description,
                    onClick         : async () => {
                        gd.openNew('view', {type: ViewType.PROJECT_CALENDAR, location: options.navigationSectionType})
                    }
                },
                {
                    typeId          : ViewType.CUSTOM_VIEW_EVENTS_SUMMARY,
                    iconSvg         : CUSTOM_VIEW_EVENTS_SUMMARY_CONFIG.iconSvg,
                    title           : CUSTOM_VIEW_EVENTS_SUMMARY_CONFIG.name,
                    description     : CUSTOM_VIEW_EVENTS_SUMMARY_CONFIG.description,
                    onClick         : async () => {
                        gd.openNew('view', {type: ViewType.CUSTOM_VIEW_EVENTS_SUMMARY, location: options.navigationSectionType})
                    }
                },
            ],
        },
        {
            id          : 'collaboration',
            type        : AddView_GroupType.GROUP,
            icon        : 'i5-users',
            title       : 'Collaboration',
            items       : [
                /*{
                    typeId          : ViewType.MY_DOCUMENTS,
                    iconSvg         : MY_DOCUMENTS_CONFIG.iconSvg,
                    title           : MY_DOCUMENTS_CONFIG.name,
                    description     : MY_DOCUMENTS_CONFIG.description,
                    alreadyExists   : existingMyWorkViews.includes(ViewType.MY_DOCUMENTS),
                    onClick         : async () => {
                        // Click on view which already added + singleton -> goto View
                        if (existingMyWorkViews.includes(ViewType.MY_DOCUMENTS)) {
                            gd.goTo(MY_DOCUMENTS_CONFIG.url)
                            return
                        }

                        gd.openNew('view', {type: ViewType.MY_DOCUMENTS, location: getCustomViewDefaultLocation(ViewType.MY_DOCUMENTS)})
                    }
                },
                {
                    typeId          : ViewType.MY_GOALS,
                    iconSvg         : MY_GOALS_CONFIG.iconSvg,
                    title           : MY_GOALS_CONFIG.name,
                    description     : MY_GOALS_CONFIG.description,
                    alreadyExists   : existingMyWorkViews.includes(ViewType.MY_GOALS),
                    onClick         : async () => {
                        // Click on view which already added + singleton -> goto View
                        if (existingMyWorkViews.includes(ViewType.MY_GOALS)) {
                            gd.goTo(MY_GOALS_CONFIG.url)
                            return
                        }

                        gd.openNew('view', {type: ViewType.MY_GOALS, location: getCustomViewDefaultLocation(ViewType.MY_GOALS)})
                    }
                },
                {
                    typeId          : ViewType.MY_MEETINGS,
                    iconSvg         : MY_MEETINGS_CONFIG.iconSvg,
                    title           : MY_MEETINGS_CONFIG.name,
                    description     : MY_MEETINGS_CONFIG.description,
                    alreadyExists   : existingMyWorkViews.includes(ViewType.MY_MEETINGS),
                    onClick         : async () => {
                        // Click on view which already added + singleton -> goto View
                        if (existingMyWorkViews.includes(ViewType.MY_MEETINGS)) {
                            gd.goTo(MY_MEETINGS_CONFIG.url)
                            return
                        }

                        gd.openNew('view', {type: ViewType.MY_MEETINGS, location: getCustomViewDefaultLocation(ViewType.MY_MEETINGS)})
                    }
                },*/

                gd.modules.expenses.enabled ? {
                    typeId          : ViewType.CUSTOM_VIEW_EXPENSES,
                    iconSvg         : CUSTOM_VIEW_EXPENSES_CONFIG.iconSvg,
                    title           : CUSTOM_VIEW_EXPENSES_CONFIG.name,
                    description     : CUSTOM_VIEW_EXPENSES_CONFIG.description,
                    onClick         : async () => {
                        gd.openNew('view', {type: ViewType.CUSTOM_VIEW_EXPENSES, location: options.navigationSectionType})
                    }
                } : null

            ],
        },
        {
            type        : AddView_GroupType.GROUP,
            id          : 'planning',
            icon        : 'i5-gantchart2',
            title       : 'Planning',
            items       : [
                {
                    typeId          : ViewType.PROJECT_GANTT,
                    iconSvg         : PROJECT_GANTT_CONFIG.iconSvg,
                    title           : PROJECT_GANTT_CONFIG.name,
                    description     : PROJECT_GANTT_CONFIG.description,
                    isPro           : !gd.company.license.projectView(ViewType.PROJECT_GANTT),
                    proFeature      : Feature.GANTT,
                    onClick         : async () => {
                        gd.openNew('view', {type: ViewType.PROJECT_GANTT, location: options.navigationSectionType})
                    }
                },
                {
                    typeId          : ViewType.PROJECT_WORKLOAD,
                    iconSvg         : PROJECT_WORKLOAD_CONFIG.iconSvg,
                    title           : PROJECT_WORKLOAD_CONFIG.name,
                    description     : PROJECT_WORKLOAD_CONFIG.description,
                    isPro           : !gd.company.license.projectView(ViewType.PROJECT_WORKLOAD),
                    proFeature      : Feature.WORKLOAD,
                    onClick         : async () => {
                        gd.openNew('view', {type: ViewType.PROJECT_WORKLOAD, location: options.navigationSectionType})
                    }
                },
            ],
        },


        {
            type        : AddView_GroupType.GROUP,
            id          : 'progress',
            icon        : 'i5-chart-bar',
            title       : 'Progress & Reports',
            items       : [
                {
                    typeId          : ViewType.PROJECT_ACTIVITY,
                    iconSvg         : PROJECT_ACTIVITY_CONFIG.iconSvg,
                    title           : PROJECT_ACTIVITY_CONFIG.name,
                    description     : PROJECT_ACTIVITY_CONFIG.description,
                    onClick         : async () => {
                        gd.openNew('view', {type: ViewType.PROJECT_ACTIVITY, location: options.navigationSectionType})
                    }
                },

                {
                    typeId          : ViewType.CUSTOM_VIEW_WHATS_DONE,
                    iconSvg         : CUSTOM_VIEW_WHATS_DONE_CONFIG.iconSvg,
                    title           : CUSTOM_VIEW_WHATS_DONE_CONFIG.name,
                    description     : CUSTOM_VIEW_WHATS_DONE_CONFIG.description,
                    onClick         : async () => {
                        gd.openNew('view', {type: ViewType.CUSTOM_VIEW_WHATS_DONE, location: options.navigationSectionType})
                    }
                },

                {
                    typeId          : ViewType.CUSTOM_VIEW_PASTDUE,
                    iconSvg         : CUSTOM_VIEW_PASTDUE_CONFIG.iconSvg,
                    title           : CUSTOM_VIEW_PASTDUE_CONFIG.name,
                    description     : CUSTOM_VIEW_PASTDUE_CONFIG.description,
                    onClick         : async () => {
                        gd.openNew('view', {type: ViewType.CUSTOM_VIEW_PASTDUE, location: options.navigationSectionType})
                    }
                },

                {
                    typeId          : ViewType.CUSTOM_VIEW_PRIORITIES,
                    iconSvg         : CUSTOM_VIEW_PRIORITIES_CONFIG.iconSvg,
                    title           : CUSTOM_VIEW_PRIORITIES_CONFIG.name,
                    description     : CUSTOM_VIEW_PRIORITIES_CONFIG.description,
                    onClick         : async () => {
                        gd.openNew('view', {type: ViewType.CUSTOM_VIEW_PRIORITIES, location: options.navigationSectionType})
                    }
                },

                {
                    typeId          : ViewType.CUSTOM_VIEW_ACTION_REQUIRED,
                    iconSvg         : CUSTOM_VIEW_ACTION_REQUIRED_CONFIG.iconSvg,
                    title           : CUSTOM_VIEW_ACTION_REQUIRED_CONFIG.name,
                    description     : CUSTOM_VIEW_ACTION_REQUIRED_CONFIG.description,
                    onClick         : async () => {
                        gd.openNew('view', {type: ViewType.CUSTOM_VIEW_ACTION_REQUIRED, location: options.navigationSectionType})
                    }
                },

                {
                    typeId          : ViewType.CUSTOM_VIEW_TASKS_BY_USER,
                    iconSvg         : CUSTOM_VIEW_TASKS_BY_USER_CONFIG.iconSvg,
                    title           : CUSTOM_VIEW_TASKS_BY_USER_CONFIG.name,
                    description     : CUSTOM_VIEW_TASKS_BY_USER_CONFIG.description,
                    onClick         : async () => {
                        gd.openNew('view', {type: ViewType.CUSTOM_VIEW_TASKS_BY_USER, location: options.navigationSectionType})
                    }
                },

                gd.modules.customEntities.enabled ? {
                    typeId          : ViewType.CUSTOM_VIEW_CUSTOM_ENTITY_GLIST,
                    iconSvg         : CUSTOM_VIEW_CUSTOM_ENTITY_GLIST_CONFIG.iconSvg,
                    title           : CUSTOM_VIEW_CUSTOM_ENTITY_GLIST_CONFIG.name,
                    description     : CUSTOM_VIEW_CUSTOM_ENTITY_GLIST_CONFIG.description,
                    onClick         : async () => {
                        gd.openNew('view', {type: ViewType.CUSTOM_VIEW_CUSTOM_ENTITY_GLIST, location: options.navigationSectionType})
                    }
                } : null

            ],
        },
        /*{type: AddView_GroupType.SEPARATOR},
        {
            type        : AddView_GroupType.GROUP,
            id          : 'personal',
            icon        : 'i5-my-time',
            title       : 'Personal',
            items       : _.compact([
                {
                    typeId          : ViewType.MY_TASKS_LIST,
                    iconSvg         : MY_TASKS_LIST_CONFIG.iconSvg,
                    title           : MY_TASKS_LIST_CONFIG.name,
                    description     : MY_TASKS_LIST_CONFIG.description,
                    alreadyExists   : existingMyWorkViews.includes(ViewType.MY_TASKS_LIST),
                    onClick         : async () => {
                        // Click on view which already added + singleton -> goto View
                        if (existingMyWorkViews.includes(ViewType.MY_TASKS_LIST)) {
                            gd.goTo(MY_TASKS_LIST_CONFIG.url)
                            return
                        }

                        gd.openNew('view', {type: ViewType.MY_TASKS_LIST, location: getCustomViewDefaultLocation(ViewType.MY_TASKS_LIST)})
                    }
                },
                {
                    typeId          : ViewType.MY_WORK_CALENDAR,
                    iconSvg         : MY_WORK_CALENDAR_CONFIG.iconSvg,
                    title           : MY_WORK_CALENDAR_CONFIG.name,
                    description     : MY_WORK_CALENDAR_CONFIG.description,
                    alreadyExists   : existingMyWorkViews.includes(ViewType.MY_WORK_CALENDAR),
                    onClick         : async () => {
                        // Click on view which already added + singleton -> goto View
                        if (existingMyWorkViews.includes(ViewType.MY_WORK_CALENDAR)) {
                            gd.goTo(MY_WORK_CALENDAR_CONFIG.url)
                            return
                        }

                        gd.openNew('view', {type: ViewType.MY_WORK_CALENDAR, location: getCustomViewDefaultLocation(ViewType.MY_WORK_CALENDAR)})
                    }
                },
                {
                    typeId          : ViewType.MY_WORK_WORKLOAD,
                    iconSvg         : MY_WORK_WORKLOAD_CONFIG.iconSvg,
                    title           : MY_WORK_WORKLOAD_CONFIG.name,
                    description     : MY_WORK_WORKLOAD_CONFIG.description,
                    alreadyExists   : existingMyWorkViews.includes(ViewType.MY_WORK_WORKLOAD),
                    onClick         : async () => {
                        // Click on view which already added + singleton -> goto View
                        if (existingMyWorkViews.includes(ViewType.MY_WORK_WORKLOAD)) {
                            gd.goTo(MY_WORK_WORKLOAD_CONFIG.url)
                            return
                        }

                        gd.openNew('view', {type: ViewType.MY_WORK_WORKLOAD, location: getCustomViewDefaultLocation(ViewType.MY_WORK_WORKLOAD)})
                    }
                },
                {
                    typeId          : ViewType.MY_TIME,
                    iconSvg         : MY_TIME_CONFIG.iconSvg,
                    title           : MY_TIME_CONFIG.name,
                    description     : MY_TIME_CONFIG.description,
                    alreadyExists   : existingMyWorkViews.includes(ViewType.MY_TIME),
                    onClick         : async () => {
                        // Click on view which already added + singleton -> goto View
                        if (existingMyWorkViews.includes(ViewType.MY_TIME)) {
                            gd.goTo(MY_TIME_CONFIG.url)
                            return
                        }

                        gd.openNew('view', {type: ViewType.MY_TIME, location: getCustomViewDefaultLocation(ViewType.MY_TIME)})
                    }
                },
                {
                    typeId          : ViewType.MY_ATTENDANCE,
                    iconSvg         : MY_ATTENDANCE_CONFIG.iconSvg,
                    title           : MY_ATTENDANCE_CONFIG.name,
                    description     : MY_ATTENDANCE_CONFIG.description,
                    alreadyExists   : existingMyWorkViews.includes(ViewType.MY_ATTENDANCE),
                    onClick         : async () => {
                        // Click on view which already added + singleton -> goto View
                        if (existingMyWorkViews.includes(ViewType.MY_ATTENDANCE)) {
                            gd.goTo(MY_ATTENDANCE_CONFIG.url)
                            return
                        }

                        gd.openNew('view', {type: ViewType.MY_ATTENDANCE, location: getCustomViewDefaultLocation(ViewType.MY_ATTENDANCE)})
                    }
                },
                {
                    typeId          : ViewType.MY_NOTES,
                    iconSvg         : MY_NOTES_CONFIG.iconSvg,
                    title           : MY_NOTES_CONFIG.name,
                    description     : MY_NOTES_CONFIG.description,
                    alreadyExists   : existingMyWorkViews.includes(ViewType.MY_NOTES),
                    onClick         : async () => {
                        // Click on view which already added + singleton -> goto View
                        if (existingMyWorkViews.includes(ViewType.MY_NOTES)) {
                            gd.goTo(MY_NOTES_CONFIG.url)
                            return
                        }

                        gd.openNew('view', {type: ViewType.MY_NOTES, location: getCustomViewDefaultLocation(ViewType.MY_NOTES)})
                    }
                },
                {
                    typeId          : ViewType.MY_RECENT,
                    iconSvg         : MY_RECENT_CONFIG.iconSvg,
                    title           : MY_RECENT_CONFIG.name,
                    description     : MY_RECENT_CONFIG.description,
                    alreadyExists   : existingMyWorkViews.includes(ViewType.MY_RECENT),
                    onClick         : async () => {
                        // Click on view which already added + singleton -> goto View
                        if (existingMyWorkViews.includes(ViewType.MY_RECENT)) {
                            gd.goTo(MY_RECENT_CONFIG.url)
                            return
                        }

                        gd.openNew('view', {type: ViewType.MY_RECENT, location: getCustomViewDefaultLocation(ViewType.MY_RECENT)})
                    }
                },
            ]),
        },*/
    ]

    if (includeAll) {
        structure.push({type: AddView_GroupType.SEPARATOR})

        structure.push({
            type        : AddView_GroupType.GROUP,
            id          : 'portfolio',
            icon        : 'i5-project', //i5-portfolio
            title       : 'Portfolio',
            items       : [
                {
                    typeId          : ViewType.PROJECTS_PORTFOLIO,
                    iconSvg         : PROJECTS_PORTFOLIO_CONFIG.iconSvg,
                    title           : PROJECTS_PORTFOLIO_CONFIG.name,
                    description     : PROJECTS_PORTFOLIO_CONFIG.description,
                    onClick         : async () => {
                        gd.openNew(QuickAddItemType.PORTFOLIO, {type: ViewType.PROJECTS_PORTFOLIO, location: options.navigationSectionType})
                    }
                },
                {
                    typeId          : ViewType.PROJECTS_PROJECTS_LIST,
                    iconSvg         : PROJECTS_PROJECTS_LIST_CONFIG.iconSvg,
                    title           : PROJECTS_PROJECTS_LIST_CONFIG.name,
                    description     : PROJECTS_PROJECTS_LIST_CONFIG.description,
                    onClick         : async () => {
                        gd.openNew(QuickAddItemType.PORTFOLIO, {type: ViewType.PROJECTS_PROJECTS_LIST, location: options.navigationSectionType})
                    }
                },
            ],
        })

        structure.push({
            type        : AddView_GroupType.GROUP,
            id          : 'dashboard',
            icon        : 'i5-dashboard',
            title       : 'Dashboard',
            items       : [
                {
                    typeId          : 'from-scratch',
                    iconSvg         : 'isvg-view-dashboard',
                    title           : 'From scratch',
                    description     : 'Create dashboard from scratch',
                    onClick         : () => {
                        createCustomDashboard({
                            templateId      : 'empty',
                            name            : 'Create from scratch',
                            description     : 'Create a personalized dashboard from scratch.',
                            preview         : 'add-custom-dashboard.svg',
                            dashboardType   : DashboardType.CUSTOM,
                            configFunction  : ()=>{}
                        }, {
                            location: gd.layout.navigation.state.currentSection?.space?.id === gd.spaces.projects.id ? 'projects': undefined
                        })
                    }
                },
                {
                    typeId          : 'from-template',
                    iconSvg         : 'isvg-view-dashboard',
                    title           : 'From template',
                    description     : 'Create dashboard from template',
                    onClick         : () => {
                        gd.openNew(QuickAddItemType.DASHBOARD, {
                            location: gd.layout.navigation.state.currentSection?.space?.id === gd.spaces.projects.id ? 'projects': undefined
                        })
                    }
                }
            ]
        })
    }

    const availableViews = PermissionsCustomView.getAllAvailable()

    // filter out groups without items
    structure = _.filter(structure, (group:AddView_Group)=>{
        return group.type === AddView_GroupType.SEPARATOR || !_.isEmpty(group.items)
    })

    return _.map(structure, (group:AddView_Group)=>{
        if (group.type === AddView_GroupType.SEPARATOR) {
            return group
        }

        switch (group.id) {
            case 'dashboard':
                /*do nothing*/
                break

            default         :
                group.items = _.filter(group.items, (viewItem)=>availableViews.includes(viewItem?.typeId))
        }

        return group
    })
}
